import {api} from "@/configs/api";

export default class AcessibilidadeService {

    static async getAll() {
        return api.get('/acessibilidade')
    }

    static async addAcessibilidade(params)
    {
        return api.post('/acessibilidade', params)
    }

    static async editAcessibilidade(id, params)
    {
        return api.put(`/acessibilidade/${id}`, params)
    }

    static async getAcessibilidade(id)
    {
        return api.get(`/acessibilidade/${id}`)
    }

    static async deleteAcessibilidade(id)
    {
        return api.delete(`/acessibilidade/${id}`)
    }

    static async alteraStatusAcessibilidade(id)
    {
        return api.put(`/acessibilidade/status/${id}`)
    }

}